import { render, staticRenderFns } from "./CompatabilityLoveForm.vue?vue&type=template&id=7a6fa66a&scoped=true&"
import script from "./CompatabilityLoveForm.vue?vue&type=script&lang=js&"
export * from "./CompatabilityLoveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6fa66a",
  null
  
)

export default component.exports